<template>
  <div>
    <vs-popup
      classContent="popup-example"
      title="Assigned"
      :active.sync="openAssignes"
    >
      <div
        class="modal-content p-4"
        v-if="receivers.noteReceiverStudent.length > 0"
      >
        <h6 class="mb-4">Assigned Students</h6>
        <div class="cstm_vuexy_table table-responsive">
          <table>
            <thead>
              <tr>
                <th style="width: 100px">Image</th>
                <th>Name</th>
                <!-- <th style="width: 50px">Action</th> -->
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(student, index) in receivers.noteReceiverStudent"
                :key="index"
              >
                <td>
                  <img
                    style="
                      width: 36px;
                      height: 36px;
                      object-fit: contain;
                      border-radius: 100%;
                    "
                    v-if="student.picture"
                    :src="student.picture"
                  />
                  <svg
                    v-else
                    style="width: 40px; height: 40px; object-fit: contain"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="user-circle"
                    class="svg-inline--fa fa-user-circle fa-w-16"
                    role="img"
                    viewBox="0 0 496 512"
                  >
                    <path
                      fill="currentColor"
                      d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
                    />
                  </svg>
                </td>
                <td>{{ student.first_name }} {{ student.last_name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="modal-content p-4"
        v-if="receivers.noteReceiverParent.length > 0"
      >
        <h6 class="mb-4">Assigned Parents</h6>
        <div class="cstm_vuexy_table table-responsive">
          <table>
            <thead>
              <tr>
                <th style="width: 100px">Image</th>
                <th>Name</th>
                <!-- <th style="width: 50px">Action</th> -->
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(parent, index) in receivers.noteReceiverParent"
                :key="index"
              >
                <td>
                  <img
                    style="
                      width: 36px;
                      height: 36px;
                      object-fit: contain;
                      border-radius: 100%;
                    "
                    v-if="parent.picture"
                    :src="parent.picture"
                  />
                  <svg
                    v-else
                    style="width: 40px; height: 40px; object-fit: contain"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="user-circle"
                    class="svg-inline--fa fa-user-circle fa-w-16"
                    role="img"
                    viewBox="0 0 496 512"
                  >
                    <path
                      fill="currentColor"
                      d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
                    />
                  </svg>
                </td>
                <td>{{ parent.first_name }} {{ parent.last_name }}</td>
                <!-- <td class="text-center">
                  <vs-icon
                    color="danger"
                    icon-pack="feather"
                    icon="icon-trash"
                  />
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="modal-content p-4"
        v-if="receivers.noteReceiverUser.length > 0"
      >
        <h6 class="mb-4">Assigned Staffs</h6>
        <div class="cstm_vuexy_table table-responsive">
          <table>
            <thead>
              <tr>
                <th style="width: 100px">Image</th>
                <th>Name</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(staff, index) in receivers.noteReceiverUser"
                :key="index"
              >
                <td>
                  <img
                    style="
                      width: 36px;
                      height: 36px;
                      object-fit: contain;
                      border-radius: 100%;
                    "
                    v-if="staff.picture"
                    :src="staff.picture"
                  />
                  <svg
                    v-else
                    style="width: 40px; height: 40px; object-fit: contain"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    data-prefix="fas"
                    data-icon="user-circle"
                    class="svg-inline--fa fa-user-circle fa-w-16"
                    role="img"
                    viewBox="0 0 496 512"
                  >
                    <path
                      fill="currentColor"
                      d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm0 96c48.6 0 88 39.4 88 88s-39.4 88-88 88-88-39.4-88-88 39.4-88 88-88zm0 344c-58.7 0-111.3-26.6-146.5-68.2 18.8-35.4 55.6-59.8 98.5-59.8 2.4 0 4.8.4 7.1 1.1 13 4.2 26.6 6.9 40.9 6.9 14.3 0 28-2.7 40.9-6.9 2.3-.7 4.7-1.1 7.1-1.1 42.9 0 79.7 24.4 98.5 59.8C359.3 421.4 306.7 448 248 448z"
                    />
                  </svg>
                </td>
                <td>{{ staff.first_name }} {{ staff.last_name }}</td>
                <!-- <td class="text-center">
                  <vs-icon
                    color="danger"      //by shankhadeepa
                    icon-pack="feather"
                    icon="icon-trash"
                  />
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>
export default {
  props: {
    openAssignes: false,
    receivers: {
      default: []
    }
  },
  watch: {
    openAssignes () {
      if (!this.openAssignes) {
        this.$emit('closeAssigned', false)
      }
    }
  },
  data () {
    return {}
  }
}
</script>